
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Admin from './Component/Admin';
import Login from './Component/Login';
import Shopkeeper_Block_List from './Component/Shopkeeper_Block_List';
import UserList from './Component/UserList';
import Catalogs from './Component/Catalogs';
import SpamList from './Component/SpamList';

function App() {
  return (
    <div>
      <BrowserRouter>
      <Routes>
      <Route path='/' element={<Login/>}/>
        <Route path='/admin' element={<Admin/>}/>
        <Route path='/shopkeeper' element={<Shopkeeper_Block_List/>}/>
        <Route path='/userlist' element={<UserList/>}/>
        <Route path='/catalogs' element={<Catalogs/>}/>
        <Route path='/spam' element={<SpamList/>}/>

      </Routes>
      </BrowserRouter>
      </div>
  );
}

export default App;
